import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import createInsightsDashboardContainer from '../shared/createInsightsDashboardContainer';

import NetworkPerformancePage from './NetworkPerformancePage';

const { Context, useDashboardContext, Container } = createInsightsDashboardContainer({
  preferenceKey: 'networkPerformanceProviderType',
  useSelectedGroupType: () => useNetworkPerformanceStore((state) => state.selectedGroupType),
  useActions: useNetworkPerformanceActions,
  Page: NetworkPerformancePage,
});

export const NetworkPerformanceContext = Context;
export const useNetworkPerformanceContext = useDashboardContext;
export default Container;
